const AddressBlock = ({ title, subTitle, lines }) => (
  <div className="mt-3">
    <div className="flex flex-col text-lg">
      <div className="font-semibold text-lime-600">{title}</div>
      <div className="font-bold italic">{subTitle}</div>
      {lines.map((line, index) => (
        <div key={index}>{line}</div>
      ))}
    </div>
  </div>
);

export default AddressBlock;
